<div class="main-footer-wrapper">
    <div class="client-footer-wrapper custom-footer">
        <div class="logo">
            <img *ngIf="clientObject.clientFooterLogo" src="{{clientObject.clientFooterLogo}}" alt="client logo"
                (click)="goToHomePage()">
        </div>
        <div class="contact-us">
            <div class="header-item contact-us-title"><span>{{'GENERAL.CONTACT' | translate}}</span>
            </div>
            <div class="body-item contact-us-address-line-1">
                <span class="location-text" *ngIf="locationObject !== null">{{
                    locationObject
                    }}</span>
            </div>
            <div class="body-item contact-us-open-days"><span>{{clientObject?.contactUs?.openDays | translate}}</span></div>
            <div class="body-item contact-us-open-hours">
                <span class="open-hours-text">{{clientObject?.contactUs?.openHours | translate }}</span>
            </div>
            <div class="contact-us-email">
                <span class="mail-text"><a class="body-item" href="mailto:{{clientObject?.contactUs?.email}}" mat-button
                        [ngStyle]="{'padding': '0', 'line-height': '0' }">{{clientObject?.contactUs?.email}}</a></span>
            </div>
            <div class="contact-us-phone-nr">
                <span class="phone-text"><a class="body-item" href="tel:{{clientObject?.contactUs?.phone}}" mat-button
                        [ngStyle]="{'padding': '0', 'line-height': '0' }">{{clientObject?.contactUs?.phone}}</a></span>
            </div>
        </div>
        <div class="menu" *ngIf="clientObject.listOfNavbarItems?.length > 0">
            <div class="header-item contact-menu-title"><span>{{'GENERAL.MENU' | translate}}</span></div>
            <span *ngFor="let item of clientObject.listOfNavbarItems">
                <a *ngIf="item.isInternal" mat-button class="body-item menu-items"
                    (click)="scrollUp();goToRoute(item);">
                    <span>{{item.url | translate}}</span>
                </a>
                <a *ngIf="!item.isInternal" href="{{item.link}}" rel="noopener noreferrer" target="_blank"
                    class="body-item menu-items" mat-button>
                    <span>{{item.url | translate}}</span>
                </a>
            </span>
            <span *ngIf="clientObject.termsAndConditions">
                <a href="{{clientObject.termsAndConditions}}" rel="noopener noreferrer" target="_blank"
                    class="body-item menu-items" mat-button>
                    <span>{{ 'GENERAL.TERMS_AND_CONDITIONS' | translate }}</span>
                </a>
            </span>
            <span *ngIf="clientObject.privacyPolicy">
                <a href="{{clientObject.privacyPolicy}}" rel="noopener noreferrer" target="_blank"
                    class="body-item menu-items" mat-button>
                    <span>{{ 'GENERAL.PRIVACY_POLICY' | translate }}</span>
                </a>
            </span>
        </div>
        <div class="social">
            <div class="header-item contact-social-title" *ngIf="showSocial()">
                <span>
                    {{'GENERAL.SOCIAL' | translate}}
                </span>
            </div>
            <div class="social-fb">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.facebook" class="body-item social-link"
                        href="{{clientObject.social.facebook}}" mat-button rel="noopener noreferrer" target="_blank">
                        Facebook
                    </a>
                </span>
            </div>
            <div class="social-insta">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.instagram" class="body-item social-link"
                        href="{{clientObject.social.instagram}}" mat-button rel="noopener noreferrer" target="_blank">
                        Instagram
                    </a>
                </span>
            </div>

            <div class="social-whatsapp">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.whatsApp" class="body-item social-link"
                        href="https://wa.me/{{clientObject.social.whatsApp}}" mat-button rel="noopener noreferrer"
                        target="_blank">
                        WhatsApp
                    </a>
                </span>
            </div>

            <div class="social-skype">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.skype" class="body-item social-link"
                        href="skype:{{clientObject.social.skype}}?call/" mat-button rel="noopener noreferrer"
                        target="_blank">
                        Skype
                    </a>
                </span>
            </div>

            <div class="social-viber">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.viber" class="body-item social-link"
                        href="viber://chat/?number=%2B{{clientObject.social.viber}}" mat-button
                        rel="noopener noreferrer" target="_blank">
                        Viber
                    </a>
                </span>
            </div>

            <div class="social-twitter">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.twitter" class="body-item social-link"
                        href="{{clientObject.social.twitter}}" mat-button rel="noopener noreferrer" target="_blank">
                        Twitter
                    </a>
                </span>
            </div>

            <div class="social-linkedin">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.linkedin" class="body-item social-link"
                        href="{{clientObject.social.linkedin}}" mat-button rel="noopener noreferrer" target="_blank">
                        LinkedIn
                    </a>
                </span>
            </div>

            <div class="social-youtube">
                <span>
                    <a style="text-align: left;" *ngIf="clientObject.social?.youtube" class="body-item social-link"
                        href="{{clientObject.social.youtube}}" mat-button rel="noopener noreferrer" target="_blank">
                        Youtube
                    </a>
                </span>
            </div>

        </div>
    </div>
</div>
<a class="footer-wrapper" href="https://www.machineric.com" target="_blank" rel="noopener external">
    <p class="footer-text">
        Powered by
    </p>
    <div class="footer-image">
        <svg-icon [src]="'https://files2.staging.machineric.com/assets/icons_social/machineric_powered.svg'"></svg-icon>
    </div>
</a>